{
  "templateLibrary": "Template Library",
  "title": "{{name}} Template Library",
  "description": "Get best practice Views, Boards, Screens (and more) for your logs. Install, edit or remove pre-configured observability Templates for your infrastructure in just a few clicks.",
  "learnMore": "Template Documentation",
  "learnMoreTitle": "Learn more about the {{title}} Template",
  "getStarted": "Get Started",
  "edit": "Edit",
  "noResults": "We're sorry but there are no Templates available.",
  "listError": "Unable to contact the Template Library.",
  "errorModal": {
    "title": "Operation failed",
    "message": "We're sorry but something went wrong. Please try again shortly or contact support."
  },
  "installedSuccessTitle": "Template applied",
  "updatedSuccessTitle": "Template updated",
  "removedSuccessTitle": "Template removed",
  "installedSuccessMessage": "The {{ title }} Template was successfully applied to the account.  Any of the applied Template items can be further customized in-app.",
  "updatedSuccessMessage": "Installed Template items have been successfully added/removed for the account.",
  "removedSuccessMessage": "The items in the {{ title }} Template have been successfully removed from this account. If you have any feedback about this Template, please reach out to us at <a href=\"mailto:product@$t(common:defaultHost)\" target=\"_blank\" rel=\"noopener noreferrer\">product@$t(common:defaultHost)</a>.",
  "takeATourAction": "Take a tour",
  "closeAction": "Ok got it!",
  "template": "Template",
  "modalDescription": "Apply the {{ title }} Template containing any combination of pre-configured Views, Boards, Screens, Exclusion Rules, and Parsing Templates.",
  "yourOrg": "Your Organization",
  "buttons": {
    "save": "Save changes",
    "remove": "Remove template",
    "apply": "Apply template",
    "docs": "Template documentation"
  },
  "modified": "{{ count }} modified",
  "userModified": "User modified, not configurable via Template Library",
  "adminOnlyInstall": "Admin permissions are required to install Templates with Exclusion Rules or Parsing Rules",
  "adminOnlyModifyRemove": "Admin permissions are required to modify or remove Templates with Exclusion Rules or Parsing Rules",
  "parsingTemplateWarning": "<strong>Note:</strong> Deselecting Parsing Templates may result in other parts of the Template not working as expected.",
  "notification": {
    "title": "Template Available",
    "goToLink": "Go to the Template Library",
    "message": "Get best practices for <strong>{{templateNames}}</strong> setup in just a few clicks."
  },
  "confirmDeleteModal": {
    "title": "Remove Template",
    "message": "Are you sure you want to remove the {{ title }} template and all its items?",
    "forceRemove": "Remove all modified items?",
    "remove": "Remove"
  }
}